import { render, staticRenderFns } from "./RealizadoPor.vue?vue&type=template&id=cb84d6b6&"
import script from "./RealizadoPor.vue?vue&type=script&lang=js&"
export * from "./RealizadoPor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports